import apiClient from './client';

export const notificationService = {
    async getNotifications({ limit = 50, unreadOnly = false } = {}) {
        const query = new URLSearchParams({
            limit: String(limit),
            unreadOnly: unreadOnly ? 'true' : 'false',
        });
        return apiClient(`/notifications?${query.toString()}`);
    },

    async markRead(notificationId) {
        return apiClient(`/notifications/${notificationId}/read`, {
            method: 'PUT',
        });
    },

    async markAllRead() {
        return apiClient('/notifications/read-all', {
            method: 'PUT',
        });
    },
};

